import React from 'react';
import { motion } from 'framer-motion';
import insuranceImg from "../assets/insurance.png";
import banner2 from '../assets/banner2.png';
import kidBg from "../assets/bgcloud.png";
import { Stethoscope, ShieldCheck, Wallet,Users } from 'lucide-react';
import insReg from "../assets/insurance-reg.png"
import insWhy  from "../assets/insurance-why.png"

const Insurance = () => {
 
  return (
    
    <div className="bg-white min-h-screen">
      {/* SECTION 1: WHAT IT IS (Image Left, Text Right) */}
          <section
  className="relative py-16 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  

   <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
           Insurance 
        </h3>

  <div
    className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
    style={{
      background:
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
    }}
  />
</section>



      

       <section className="relative pt-20 pb-20 overflow-hidden bg-white">
        {/* Background Decor - Restored width for symmetry */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50 -z-10 hidden lg:block" />

        <div className="max-w-7xl mx-auto px-6 lg:px-24">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-15">
            
            {/* LEFT SIDE: CONTENT */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="w-full lg:w-3/5" // Takes up 60% of the space
            >
              {/*
              <h3 className="text-[24px] md:text-[40px] text-slate-900 tracking-tight font-medium mb-6">
                Insurance Products in India
              </h3>
            */}
              <div className="space-y-6 max-w-xl"> {/* Prevents text from leaking into the center */}
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                Insurance is a financial safety net that protects individuals and families against life, health, property, and income-related risks. 
                </p>
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                  It ensures financial security during unforeseen events while supporting long-term planning and wealth preservation.
                </p>
                <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-8 italic">
                 Comprehensive Insurance Strategies provide a vital safety net where tailored coverage meets robust risk management, ensuring your family’s financial future is protected with absolute certainty.
                </p>
              </div>
            </motion.div>

            {/* RIGHT SIDE: IMAGE */}
            <motion.div 
              className="w-full lg:w-2/5 flex justify-end" // Takes up 40% and pins to the right margin
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="relative w-full max-w-[450px] mt-6"> 
                <div className="overflow-hidden rounded-sm"> {/* Clean edge like Our Story */}
                  <img 
                    src={insuranceImg} 
                    alt="Mutual Funds Overview" 
                    className="w-full h-auto object-cover aspect-[5/3]"
                  />
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

    <section 
  className="relative w-full pt-20 pb-28 overflow-hidden"
  style={{ 
    backgroundImage: `url(${kidBg})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center' 
  }}
>
  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
    
    <div className="text-center mb-12">
      
      <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
        Types of Insurance Products
      </h3>
      
      <p className="text-slate-600 text-lg md:text-xl leading-relaxed max-w-3xl mx-auto ">
        Tailored protection plans designed to safeguard your family and assets against life's uncertainties.
        </p> 
    </div>

    {/* Reduced gap from 8 to 4 for compactness */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {[
  {
    title: "Life Insurance",
    desc: "Provides financial protection to dependents via Term Plans, Endowment Plans, ULIPs, and Whole Life Policies.",
    //icon: <Heart size={20} className="text-red-600" strokeWidth={2} />
    icon: <Users size={20} className="text-red-600" strokeWidth={2} />
  },
  {
    title: "Health Insurance",
    desc: "Covers medical expenses and hospitalization through Individual, Family Floater, and Critical Illness Plans.",
    icon: <Stethoscope size={20} className="text-red-600" strokeWidth={2} />
  },
  {
    title: "General Insurance",
    desc: "Comprehensive coverage for non-life risks including motor, home, travel, and commercial assets.",
    icon: <ShieldCheck size={20} className="text-red-600" strokeWidth={2} />
  },
  {
    title: "Pension / Annuity Plans",
    desc: "Strategic retirement solutions designed to provide a guaranteed and steady income stream post-retirement.",
    icon: <Wallet size={20} className="text-red-600" strokeWidth={2} />
  }
].map((item, index) => (
        <motion.div 
          key={index}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.05 }}
          
          className="p-6 rounded-xl bg-white/60 backdrop-blur-md border border-white/40 hover:bg-white/80 transition-all duration-300 shadow-sm"
        >
          <div className="flex items-center gap-3 mb-3">
            {/* Removed the background box from the icon to eliminate white space */}
            <div className="flex-shrink-0">
              {item.icon}
            </div>
            <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
              {item.title}
            </h4>
          </div>

          {/* Reduced left padding as there is no icon box anymore */}
          <p className="text-slate-600 text-base md:text-lg font-medium pl-8">
            {item.desc}
          </p>
        </motion.div>
      ))}
    </div>
  </div>
</section>

<section 
  className="relative pt-12 md:pt-20  md:pt-16 overflow-hidden bg-white"
>
  {/* TOP FADE: Blends section smoothly into the one above */}
  <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-white via-white/40 to-transparent pointer-events-none z-0"></div>
  
  {/* BOTTOM FADE: Blends section smoothly into the one below */}
  <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-white via-white/40 to-transparent pointer-events-none z-0"></div>

  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

      {/* LEFT: SECTION ANCHOR & IMAGE */}
      <div className="max-w-xl">
       
        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
          Regulatory Framework
        </h3>

        <div className="w-16 h-[3px] bg-red-600 mb-8"></div>

        <p className="text-slate-600 text-lg md:text-xl leading-relaxed mb-12">
          Insurance in India is governed by a rigorous statutory framework designed to protect policyholders and maintain market integrity.
        </p>

        {/* INTEGRATED IMAGE: Updated with soft shadow */}
        <div className="relative group">
          <img 
            src={insReg} // Update your import to point to an insurance-related graphic
            alt="Insurance Regulatory Compliance" 
            className="w-full h-auto drop-shadow-2xl rounded-2xl transform transition-transform duration-700 group-hover:scale-[1.02]"
          />
        </div>
      </div>

      {/* RIGHT: REGULATORY POINTS */}
      <div className="max-w-2xl">

        <div className="space-y-10">

          {[
            "Governed by IRDAI, which regulates insurers, pricing structures, product approvals, and mandatory solvency margins.",
            "Mandatory KYC and Suitability Assessments ensure that products are aligned with the client’s specific needs and risk profile.",
            "A mandatory 'Free-Look Period' of 15–30 days allows clients to review policy terms and cancel if they are not satisfied.",
            "Standardized Disclosure Norms require insurers to clearly share benefits, charges, exclusions, surrender rules, and claim processes.",
            "Strict Claims Settlement Regulations mandate specific timelines for claim acknowledgment and final payout to protect consumers."
          ].map((text, idx) => (
            <div key={idx} className="group flex gap-6">
              {/* FEEDBACK FIX: Number turns red on hover of the parent group */}
              <span className="text-slate-400 font-syne font-bold text-lg mt-[2px] transition-colors duration-300 group-hover:text-red-600">
                0{idx + 1}
              </span>
              <p className="text-slate-600 text-base md:text-lg font-medium transition-colors duration-300 group-hover:text-slate-900">
                {text}
              </p>
            </div>
          ))}

        </div>

      </div>

    </div>
  </div>
</section>





<section className="relative pb-20 pt-16 min-h-[900px] flex flex-col items-center justify-center overflow-hidden bg-white">
  
  {/* CENTERED HEADER */}
  <div className="text-center mb-auto relative z-20 px-6 pt-5 pb-16">
    <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
      Why Insurance Matters
    </h3>
  </div>

  <div className="w-full relative flex flex-col items-center justify-center flex-grow">
    
    {/* FULL WIDTH IMAGE - STRETCHED BASE LAYER */}
    <div className="absolute inset-0 z-0 flex items-center justify-center overflow-hidden">
      <img 
        src={insWhy} 
        alt="Insurance Illustration" 
        className="w-full h-auto min-h-[500px] object-cover" 
      />
    </div>

    {/* EXTREME ZIG-ZAG DESCRIPTIONS */}
    <div className="relative z-10 w-full max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 h-[600px] items-center">
        {[
          "Protects family from financial uncertainty.",
          "Covers rising medical and hospitalization costs.",
          "Helps preserve long-term goals during emergencies.",
          "Enables tax benefits under Sections 80C & 80D.",
          "Acts as a foundation for a resilient financial plan."
        ].map((desc, idx) => {
          const isExtremeTop = idx % 2 === 0;

          return (
            <div 
              key={idx} 
              className={`flex flex-col items-center group transition-all duration-500
                ${isExtremeTop 
                  ? 'lg:-translate-y-[270px]' // Points 1, 3, 5 (Extreme Top)
                  : 'lg:translate-y-[170px]' // Points 2, 4 (Moved Bit Upward)
                }`}
            >
              {/* SLATE CIRCLE (Turns Red on Hover) */}
              <div className="relative z-10 flex-shrink-0 w-9 h-9 rounded-full bg-white border-[2px] border-slate-600 flex items-center justify-center transition-all duration-300 group-hover:bg-red-700 group-hover:border-red-700 mb-3 shadow-sm">
                <span className="text-slate-600 font-bold text-md transition-colors duration-300 group-hover:text-white">
                  {idx + 1}
                </span>
              </div>

              {/* DESCRIPTION ONLY - MINIMALIST */}
              <div className="max-w-[220px] text-center">
                <p className="text-slate-600 text-base md:text-lg font-medium leading-relaxed transition-colors duration-300 group-hover:text-slate-900">
                  {desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>

  </div>
</section>
    </div>
  );
};

export default Insurance;